export default __webpack_public_path__ + "static/zion-cc44808feba47e2d1dd48ee6a57e7658.jpg";